import type ILabelEnumPair from '../../global/GlobalInterfaces';
import type { ILabelValuePair } from '../../marking/MarkingInterfaces';

interface IWorkViewDetail {
  workViewId: string,
  name: string,
  description: string,
  users: Array<IEmployeeInfo>,
  layoutStyle: ILabelValuePair,
  primaryGroups: Array<IWorkViewPrimaryGroup>,
  [key: string]: unknown;
}

interface IWorkViewFilterData {
  workViewId: string
  filterType: IFilter
  totalItems: number
  shipLoggedItems: number
  lateItems: number
  stalledItems: number
  rejectedItems: number
  primaryGroupData: Array<IWorkViewPrimaryGroupData>,
}

interface IWorkViewPrimaryGroupData {
  totalItems: number
  sets: Array<IWorkViewSetData>
}

interface IWorkViewSetData {
  totalItems: number
}

interface IWorkView {
  id: string,
  name: string,
  description: string,
  layout: string
}

interface IWorkViewPrimaryGroup {
  primaryGroupId: string,
  name: string,
  sets: Array<IWorkViewSet>,
  [key: string]: unknown;
}

interface IWorkViewSet {
  workViewSetId: string,
  name: string,
  displayStyle: ILabelEnumPair,
  color: boolean,
  bins: Array<ILabelValuePair>
}

interface IEmployeeInfo {
  id:string;
  name: string;
  email: string;
  barcode:string;
  facilities: string[];
  employeeLevels:string[];
  departments: string[];
  isActive: boolean;
  [key: string]: unknown;
}

interface ICompany {
  companyId: string,
  companyName: string,
}

interface IFilter {
  label: string,
  value: number,
  color: string,
}

export const FilterTypes: IFilter[] = [
  { label: 'Total', value: 1, color: 'blue' },
  { label: 'Shipping Log', value: 2, color: 'red' },
  // { label: 'Late Items', value: 3, color: 'orange' },
  // { label: 'Stalled Items', value: 4, color: 'yellow' },
  { label: 'Rejected Items', value: 5, color: 'maroon' },
];

export type {
  IWorkViewDetail, IWorkViewFilterData, IWorkViewPrimaryGroupData, IWorkViewSetData, IWorkView, IWorkViewSet, IWorkViewPrimaryGroup, IEmployeeInfo, ICompany, IFilter,
};
